<div class="card voffset-5">
    <div class="card-body">
        <div class="row">
            <div class="col">
                <h6 class="card-title main-blue">
                    {{ item.campName }} - {{ item.sessionName }}
                </h6>
            </div>
        </div>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-sm-3 bolded">
                            {{ "PurchaseDetails.location" | translate }}
                        </div>
                        <div class="col-sm-9">
                            {{ item.clubInfo.name }} ({{ item.clubInfo.code }})
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 bolded">
                            {{ "PurchaseDetails.child" | translate }}
                        </div>
                        <div class="col-sm-9">{{ item.childFullName }}</div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">
                            {{ "PurchaseDetails.details" | translate }}
                        </div>
                        <div class="col-sm-9">
                            {{ timeVariant() }} ({{
                                item.timeVariant.fromInMinutes | timeDisplay
                            }}
                            - {{ item.timeVariant.toInMinutes | timeDisplay }})
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">
                            {{ "PurchaseDetails.campDays" | translate }}
                        </div>
                        <div class="col-sm-9">
                            @for (
                                campDay of item.campDays;
                                track campDay;
                                let i = $index
                            ) {
                                <span>
                                    {{ campDay | bcDate }}
                                    @if (i < item.campDays.length - 1) {
                                        <span>, </span>
                                    }
                                </span>
                            }
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">
                            {{ "PurchaseDetails.selectedOptions" | translate }}
                        </div>
                        @if (item.options.length > 0) {
                            <div class="col-sm-9" hznTestId="purchase-details-session-options">
                                @for (
                                    option of item.options;
                                    track option;
                                    let i = $index
                                ) {
                                    <span>
                                        {{ option }}
                                        @if (i < item.options.length - 1) {
                                            <span>, </span>
                                        }
                                    </span>
                                }
                            </div>
                        }
                        @if (item.options.length == 0) {
                            <div class="col-sm-9" hznTestId="purchase-details-session-options">
                                {{ "PurchaseDetails.noneOptions" | translate }}
                            </div>
                        }
                    </div>

                    @if (item.refundDate) {
                        <div class="row">
                            <div class="col-sm-3 bolded">
                                {{ "PurchaseDetails.refundDate" | translate }}
                            </div>
                            <div class="col-sm-9">
                                {{ item.refundDate | bcDate }}
                            </div>
                        </div>
                    }
                    @if (item.refundedBy) {
                        <div class="row">
                            <div class="col-sm-3 bolded">
                                {{ "PurchaseDetails.refundedBy" | translate }}
                            </div>
                            <div class="col-sm-9">{{ item.refundedBy }}</div>
                        </div>
                    }
                    @if (item.refundReasonInfo) {
                        <div class="row">
                            <div class="col-sm-3 bolded">
                                {{ "PurchaseDetails.refundReason" | translate }}
                            </div>
                            <div class="col-sm-9">{{ refundReason() }}</div>
                        </div>
                    }
                    @if (item.refundReasonInfo?.comment) {
                        <div class="row">
                            <div class="col-sm-3 bolded">
                                {{
                                    "PurchaseDetails.refundComment" | translate
                                }}
                            </div>
                            <div class="col-sm-9">
                                {{ item.refundReasonInfo.comment }}
                            </div>
                        </div>
                    }
                </div>
                <div class="col-sm-6">
                    <div class="row justify-content-end">
                        <div class="col-sm-10 bolded text-align-right">
                            {{ "PurchaseDetails.tuition" | translate }}
                        </div>
                        <div
                            class="col-sm-2 bolded main-green"
                            [ngClass]="{ 'old-price': item.isRefunded }"
                        >
                            {{ item.cost.netTuitionAmount | amount }}
                            @if (!item.isRefunded) {
                                <i
                                    class="fa fa-question-circle-o hoffset-10"
                                    aria-hidden="true"
                                    href="javascript:void(0)"
                                    (mouseover)="onExplanationMouseOver()"
                                    (mouseleave)="onExplanationMouseOut()"
                                >
                                </i>
                            }
                        </div>

                        <div class="explanation-popover-container right">
                            @if (isPopverVisible) {
                                <div class="bcc-popover-container">
                                    <div class="bcc-popover-right">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <span
                                                    [translate]="
                                                        'PurchaseDetails.basePrice'
                                                    "
                                                ></span>
                                                <span
                                                    class="main-green right"
                                                    >{{
                                                        item.cost.basePrice
                                                            | amount
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                        @for (
                                            discount of item.cost.discounts;
                                            track discount
                                        ) {
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <span
                                                        >{{
                                                            discount.name
                                                        }}:</span
                                                    >
                                                    <span class="main-red right"
                                                        >-{{
                                                            discount.value
                                                                | amount
                                                        }}</span
                                                    >
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    @if (item.cost.taxAmount > 0) {
                        <div class="row justify-content-end">
                            <div class="col-sm-10 bolded text-align-right">
                                {{
                                    "PurchaseDetails.tax"
                                        | translate
                                            : {
                                                  taxRate: item.cost.taxRate,
                                              }
                                }}
                            </div>
                            <div
                                class="col-sm-2 bolded main-green"
                                [ngClass]="{ 'old-price': item.isRefunded }"
                            >
                                {{ item.cost.taxAmount | amount }}
                            </div>
                        </div>
                    }

                    @if (item.cost.taxAmount > 0) {
                        <div class="row justify-content-end">
                            <div class="col-sm-10 bolded text-align-right">
                                {{ "PurchaseDetails.total" | translate }}
                            </div>
                            <div
                                class="col-sm-2 bolded main-green"
                                [ngClass]="{ 'old-price': item.isRefunded }"
                            >
                                {{ item.cost.tuitionAmount | amount }}
                            </div>
                        </div>
                    }

                    @if (item.cost.netOptionsAmount > 0) {
                        <div class="row justify-content-end mt-1">
                            <div class="col-sm-10 bolded text-align-right">
                                {{
                                    "PurchaseDetails.additionalOptions"
                                        | translate
                                }}
                            </div>
                            <div class="col-sm-2 bolded main-green">
                                {{ item.cost.netOptionsAmount | amount }}
                            </div>
                        </div>
                    }
                    @if (item.cost.optionsTaxAmount > 0) {
                        <div class="row justify-content-end">
                            <div class="col-sm-10 bolded text-align-right">
                                {{
                                    "PurchaseDetails.tax"
                                        | translate
                                            : {
                                                  taxRate: item.cost.taxRate,
                                              }
                                }}
                            </div>
                            <div class="col-sm-2 bolded main-green">
                                {{ item.cost.optionsTaxAmount | amount }}
                            </div>
                        </div>
                    }

                    @if (item.cost.optionsTaxAmount > 0) {
                        <div class="row justify-content-end">
                            <div class="col-sm-10 bolded text-align-right">
                                {{ "PurchaseDetails.total" | translate }}
                            </div>
                            <div class="col-sm-2 bolded main-green">
                                {{ item.cost.optionsAmount | amount }}
                            </div>
                        </div>
                    }

                    @if (item.refundedOptions?.length > 0) {
                        <div class="row justify-content-end mt-3">
                            <div class="col-sm-10 bolded text-align-right">
                                {{
                                    "PurchaseDetails.refundedOptions"
                                        | translate
                                }}
                            </div>
                            <div class="col-sm-2"></div>
                        </div>
                    }
                    @if (item.refundedOptions?.length > 0) {
                        <div class="row justify-content-end">
                            @for (
                                option of item.refundedOptions;
                                track option
                            ) {
                                <div class="col-sm-2 bolded old-price">
                                    {{ option.name }}
                                    {{ -option.value | amount }}
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
